import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  href: string;
  text: string;
  className?: string;
}
export function CTAButton({
  href,
  text,
  className = ''
}: CTAButtonProps) {
  return <motion.a href={href} className={`block w-full max-w-lg mx-auto bg-green-500 hover:bg-green-600 text-white font-bold text-xl md:text-2xl py-5 px-8 rounded-xl shadow-[0_4px_20px_rgba(34,197,94,0.4)] text-center cursor-pointer transition-colors ${className}`} animate={{
    scale: [1, 1.02, 1]
  }} transition={{
    repeat: Infinity,
    duration: 2,
    ease: 'easeInOut'
  }} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} data-id="element-373">
      {text}
    </motion.a>;
}